import React from "react";
import textLoader  from "../../assets/svg/textLoader.svg";
import { mainButton, mainButtonFill, buttonIcon } from "./button.module.css";

const Button = ({
  onClick,
  type,
  className,
  buttonName,
  main,
  loading,
  icon,
  ...res
}) => {
  return (
    <>
      {main === "fill" ? (
        <button
          type={type}
          className={`${className} ${mainButtonFill}`}
          onClick={onClick}
          {...res}
        >
          {buttonName}
          <span className={buttonIcon} >{icon}</span>
          {loading? <img className="buttonLoader" src={textLoader} alt="" /> : <></>}
        </button>
      ) : (
        <button
          type={type}
          className={`${className}   ${mainButton}`}
          onClick={onClick}
          {...res}
        >
          {buttonName}
          <span className={buttonIcon}>{icon}</span>
          {loading? <img className="buttonLoader" src={textLoader} alt="" /> : <></>}
        </button>
      )}
    </>
  );
};

export { Button };
